(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("../../../public/partials/base/dpf-base");

},{"../../../public/partials/base/dpf-base":2}],2:[function(require,module,exports){
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {} } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
(function ($) {
  var navBreak = 768;
  var VINLENGTH = 17;
  var nonceRefreshInProgress = false;
  var nonceRefreshPromise = null;

  // Helper: get the currently open dropdown container
  function getOpenDropdownContainer() {
    var $open = $('.dpf-form__dropdown-wrapper.open');
    return $open.length ? $open.first() : null;
  }

  // Refresh the nonce when it has expired (e.g., due to page caching)
  function refreshNonce() {
    if (nonceRefreshInProgress && nonceRefreshPromise) {
      return nonceRefreshPromise;
    }
    nonceRefreshInProgress = true;
    nonceRefreshPromise = new Promise(function (resolve, reject) {
      $.ajax({
        type: 'POST',
        url: dpf.ajax_url,
        data: {
          action: 'dpf_refresh_nonce'
        },
        success: function success(res) {
          if (res.success && res.data && res.data.nonce) {
            dpf.nonce = res.data.nonce;
            resolve(res.data.nonce);
          } else {
            reject(new Error('Invalid nonce response'));
          }
          nonceRefreshInProgress = false;
        },
        error: function error(err) {
          nonceRefreshInProgress = false;
          reject(err);
        }
      });
    });
    return nonceRefreshPromise;
  }

  // AJAX wrapper that handles nonce refresh on 403 errors
  function dpfAjax(options, isRetry) {
    return new Promise(function (resolve, reject) {
      var originalData = options.data || {};
      if (!originalData.nonce) {
        originalData.nonce = dpf.nonce;
      }
      $.ajax(Object.assign({}, options, {
        data: originalData,
        success: function success(res) {
          if (options.success) options.success(res);
          resolve(res);
        },
        error: function error(err) {
          if (!isRetry && err.status === 403) {
            refreshNonce().then(function (newNonce) {
              originalData.nonce = newNonce;
              dpfAjax(Object.assign({}, options, {
                data: originalData
              }), true).then(resolve).catch(reject);
            }).catch(function (refreshErr) {
              if (options.error) options.error(err);
              reject(err);
            });
          } else {
            if (options.error) options.error(err);
            reject(err);
          }
        }
      }));
    });
  }

  // Generic dropdown loader to reduce duplication
  function loadDropdown(_ref) {
    var action = _ref.action,
      nonce = _ref.nonce,
      payload = _ref.payload,
      fieldsetId = _ref.fieldsetId,
      itemsSelector = _ref.itemsSelector,
      handlePrev = _ref.handlePrev,
      _ref$openDropdownOnLo = _ref.openDropdownOnLoad,
      openDropdownOnLoad = _ref$openDropdownOnLo === undefined ? true : _ref$openDropdownOnLo,
      beforeInject = _ref.beforeInject,
      afterInject = _ref.afterInject,
      _ref$isRetry = _ref.isRetry,
      isRetry = _ref$isRetry === undefined ? false : _ref$isRetry;
    return new Promise(function (resolve) {
      showLoadingIndicator(fieldsetId);
      $.ajax({
        type: 'POST',
        url: dpf.ajax_url,
        data: Object.assign({
          action: action,
          nonce: nonce || dpf.nonce
        }, payload || {}),
        success: function success(res) {
          var html = beforeInject ? beforeInject(res) : res;
          $(itemsSelector).html(html);
          $("#" + fieldsetId).removeClass('hidden disabled');
          if (handlePrev) {
            var resHtml = handlePrev.resHtml,
              nameSpan = handlePrev.nameSpan,
              input = handlePrev.input;
            handlePreviousValue($(resHtml || res), $(nameSpan), $(input));
          }
          if (openDropdownOnLoad) {
            dpfOpenDropdown($("#" + fieldsetId).find('div.dpf-form__input'));
          }
          if (afterInject) afterInject(res);
          hideLoadingIndicator(fieldsetId);
          resolve();
        },
        error: function error(err) {
          // Check for 403 error (nonce expired) and retry once with fresh nonce
          if (!isRetry && err.status === 403) {
            refreshNonce().then(function (newNonce) {
              loadDropdown({
                action: action,
                nonce: newNonce,
                payload: payload,
                fieldsetId: fieldsetId,
                itemsSelector: itemsSelector,
                handlePrev: handlePrev,
                openDropdownOnLoad: openDropdownOnLoad,
                beforeInject: beforeInject,
                afterInject: afterInject,
                isRetry: true
              }).then(resolve);
            }).catch(function () {
              console.error('Failed to refresh nonce:', err);
              hideLoadingIndicator(fieldsetId);
              resolve();
            });
          } else {
            console.error(err);
            hideLoadingIndicator(fieldsetId);
            resolve();
          }
        }
      });
    });
  }
  $(document).ready(function () {
    dpfPutSearchInHeader();
    dpfMobileSearch(); // move part search div to bottom of header
    dpfHeaderSearchOffset();

    // MikMak scrollbar compensation - prevent layout shift when modal opens
    (function () {
      var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbarWidth > 0) {
        var lastOverflow = '';
        var checkOverflow = function checkOverflow() {
          var currentOverflow = getComputedStyle(document.body).overflow;
          if (currentOverflow !== lastOverflow) {
            if (currentOverflow === 'hidden') {
              document.body.style.paddingRight = scrollbarWidth + 'px';
            } else {
              document.body.style.paddingRight = '';
            }
            lastOverflow = currentOverflow;
          }
          requestAnimationFrame(checkOverflow);
        };
        requestAnimationFrame(checkOverflow);
      }
    })();
    $(".dpf-tablink").on("click", function () {
      // tab functionality
      var tabName = $(this).data("tabcontent");
      $(".dpf-tabcontent").hide();
      $(".dpf-tablink").not($(this)).removeClass("active");
      $(this).addClass("active");
      $("#" + tabName).show();
    });
    vinInput().on("input", function (e) {
      turnOffPredefinedEvents();
      toggleVinSubmit();
      showClearFiltersButton();
    });
    partNumberInput().on("input", function (e) {
      turnOffPredefinedEvents();
      togglePartNumberSubmit();
      showClearFiltersButton();
    });
    crossReferenceInput().on("input", function (e) {
      turnOffPredefinedEvents();
      toggleCrossRefSubmit();
      showClearFiltersButton();
    });

    // Maybe we should get more strict and also check for a base vehicle or part number.
    if (window.location.href.includes("part-finder-search-results")) {
      updatePartsList();
    }
    initDropdowns();
    if (window.location.href.includes("part-finder-search-results")) {
      loadEngineDetails();
    }
    takeOverFindMyPart();
    if (window.location.href.includes("installation-guides")) {
      updateGuidesList();
    }
    form().submit(handleFormSubmit);

    // Initialize HD enhancements and default search-by logic
    initHdEnhancementsOnReady();
  });

  // Check if vehicle type is auto-selected on page load
  $(document).ready(function () {
    // Check if we have form values in the URL (page load with existing search)
    var urlParams = new URLSearchParams(window.location.search);
    var hasFormValues = urlParams.has('dpfVehicleType') || urlParams.has('dpfSearchBy');

    // Only call initDefaultSearchByOnReady if the form is empty
    if (!hasFormValues) {
      initDefaultSearchByOnReady();
    }
  });
  $(window).on("resize orientationchange", function () {
    dpfMobileSearch();
    dpfHeaderSearchOffset();
  });
  $(window).on("keypress", function (e) {
    var openContainer = getOpenDropdownContainer();
    if (openContainer) {
      e.preventDefault();
      var activeValue = openContainer.siblings(".dpf-form__active-value").children("span");
      var containerChoices = openContainer.children("ul").children("li");
      var key = String.fromCharCode(e.charCode);
      if (key) {
        var newText = $("#" + activeValue.attr("id").slice(0, -4)).val() === activeValue.text().trim() ? key : activeValue.text() + key;
        activeValue.text(newText);
        containerChoices.each(function () {
          if ($(this).text().toLowerCase().startsWith(newText.toLowerCase())) {
            $(this).removeClass("hidden");
          } else {
            $(this).addClass("hidden");
          }
        });
        $("li.dpf-form__dropdown-item").removeClass("dpf-dropdown-selected");
        processRemainingOptions(containerChoices, newText);
      }
    }
  });

  // Now detect backspaces and enters.
  $(window).on("keydown", function (e) {
    var CONTROLLED_CHARACTERS = [13, 9, 8, 38, 40];
    if (!CONTROLLED_CHARACTERS.includes(e.keyCode)) return;
    var openContainer = getOpenDropdownContainer();
    if (openContainer) {
      e.preventDefault();
      var activeValue = openContainer.siblings(".dpf-form__active-value").children("span");
      var containerChoices = openContainer.children("ul").children("li");
      if (e.keyCode === 8 && activeValue.attr("id")) {
        var newText = $("#" + activeValue.attr("id").slice(0, -4)).val() === activeValue.text().trim() ? "" : activeValue.text().trim().slice(0, -1);
        activeValue.text(newText);
        containerChoices.each(function () {
          if ($(this).text().toLowerCase().startsWith(newText.toLowerCase())) {
            $(this).removeClass("hidden");
          } else {
            $(this).addClass("hidden");
          }
        });
        $("li.dpf-form__dropdown-item").removeClass("dpf-dropdown-selected");
        processRemainingOptions(containerChoices, newText);
      } else if (e.keyCode === 13 || e.keyCode === 9) {
        dpfDropdownClicked($(".dpf-dropdown-selected"));
      } else if (e.keyCode === 38) {
        var currentSelected = $("li.dpf-form__dropdown-item.dpf-dropdown-selected");
        var newSelected = currentSelected.prev();
        if (newSelected.length) {
          currentSelected.removeClass("dpf-dropdown-selected");
          newSelected.addClass("dpf-dropdown-selected");
        }
      } else if (e.keyCode === 40) {
        var _currentSelected = $("li.dpf-form__dropdown-item.dpf-dropdown-selected");
        var _newSelected = _currentSelected.next();
        if (_newSelected.length) {
          _currentSelected.removeClass("dpf-dropdown-selected");
          _newSelected.addClass("dpf-dropdown-selected");
        }
      }
    }
  });
  function processRemainingOptions(containerChoices, newText) {
    var remainingOptions = $.grep(containerChoices, function (item) {
      return !$(item).hasClass("hidden");
    });

    // Initial select the first option.
    $(remainingOptions[0]).addClass("dpf-dropdown-selected");

    // Add underline to matching portion.
    remainingOptions.forEach(function (element) {
      // use getIndices for fuzzy search
      // due to no fuzzy search, we can simplify this to only using [0]
      var indices = [0];
      var finalHtml = $(element).text().substring(0, indices[0]);
      for (var i = 0; i < indices.length; i++) {
        var end = indices[i] + newText.length;
        finalHtml += "<span class=\"underline !pl-0\">" + $(element).text().substring(indices[i], end) + "</span>";
        if (i < indices.length - 1) {
          finalHtml += $(element).text().substring(end, indices[i + 1]).replace(" ", "&nbsp;");
        } else {
          finalHtml += $(element).text().substring(end).replace(" ", "&nbsp;");
        }
      }
      $(element).html(finalHtml);
    });
  }
  $(document).on('click', 'div.dpf-show-search-form a, li.dpf-show-search-form a, a.dpf-show-search-form', function (e) {
    e.preventDefault();
    if ($("#dpfHeaderSearch").length > 0) {
      // Commonly happens away from home page.
      window.scrollTo({
        top: 0
      });

      // In order to bypass the scroll action hiding the form,
      // we need to let the scroll action finish first.
      setTimeout(function () {
        $("#dpfHeaderSearch").addClass('search-visible');
        dpfHeaderSearchOffset();
      }, 20);
    } else {
      // Commonly happens on home page.
      document.getElementById("dpfSearchFormWrapper").scrollIntoView();
    }
    if ($(window).innerWidth() < navBreak) {
      disableScroll();
    }
  });
  function dpfHeaderSearchOffset() {
    // Get the header element and calculate its exact position
    var $header = $('header');
    if (!$header.length) {
      return;
    }
    var headerOffset = $header.offset();
    if (!headerOffset) {
      return;
    }
    var headerHeight = $header.outerHeight();

    // Calculate the exact position below the header
    var positionBelowHeader = headerOffset.top + headerHeight;
    var initialTop = '-1000px';
    if ($(window).innerWidth() >= navBreak) {
      initialTop = '-500px';
    }

    // Position the search panel just below the header
    $('#dpfHeaderSearch.search-visible').css('top', positionBelowHeader + 'px');
    $('#dpfHeaderSearch:not(.search-visible)').css('top', initialTop);
  }
  function dpfMobileSearch() {
    if ($(window).innerWidth() < navBreak) {
      var activeTab = $(".dpf-tablink.active").text();
      $(".dpf-search-header-nav-active").text(activeTab);
      $(".dpf-search-header-nav-active.tab-nav-open").on("click", function () {
        $(this).siblings(".dpf-tab-nav").removeClass("open").slideUp();
        $(this).removeClass("tab-nav-open");
      });
      $(".dpf-search-header-nav-active:not(tab-nav-open)").on("click", function () {
        $(this).siblings(".dpf-tab-nav").addClass("open").slideDown();
        $(this).addClass("tab-nav-open");
      });
      $(".dpf-tablink").on("click", function () {
        var selectedTab = $(this).text();
        $(".dpf-search-header-nav-active").text(selectedTab);
        $(this).parents(".dpf-tab-nav").removeClass("open").slideUp();
      });
    } else {
      $(".dpf-tab-nav").removeClass("open").slideUp();
    }
  }
  function initDropdowns() {
    var pageLoad = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return new Promise(function (resolve) {
      // loadMakes and other functions will abort if the arguments passed are not valid,
      // so we do not need to check in this function
      var setYear = $("#dpfVehicleYear").val();
      var setMake = $("#dpfVehicleMake").val();
      var setModel = $("#dpfVehicleBaseVehicle").val();
      var setEngine = $("#dpfVehicleEngine").val();
      var setTrim = $("#dpfVehicleTrim").val();

      // Only load dropdowns that have values or are needed for the current form state
      var promises = [];

      // Only load Years if there's a year value or if we're on a page that needs it
      if (setYear || !pageLoad) {
        promises.push(loadYears());
      }
      if (setYear) {
        promises.push(loadMakes(setYear, false));
      }
      if (setYear && setMake) {
        promises.push(loadModels(setYear, setMake, false));
      }
      if (setModel) {
        promises.push(loadEngines(setModel, false));
      }
      if (setEngine && setModel) {
        promises.push(loadTrims(setEngine, setModel, false));
      }
      if (setTrim && setModel && setEngine) {
        promises.push(loadPartTypes(setTrim, setModel, setEngine, pageLoad, false));
      }

      // If we have a base vehicle but no trim/engine, still load part types for existing searches
      if (setModel && !setTrim && pageLoad) {
        promises.push(loadPartTypes(null, setModel, null, true, false));
      }
      Promise.all(promises).then(function (_) {
        return resolve();
      });
    });
  }
  function loadEngineDetails() {
    var setEngine = $("#dpfVehicleEngine").val();
    if (setEngine) {
      $('#dpfSearchResultsSpinner').removeClass('hidden');
      $.ajax({
        type: "POST",
        url: dpf.ajax_url,
        data: {
          action: "dpf_vcdb_cc_cid",
          nonce: dpf.nonce,
          engineBaseId: setEngine
        },
        success: function success(res) {
          if (res.data) {
            if (res.data['CC']) {
              $('#dpfVehicleInfo').append("<li class=\"block sm:list-item\">CC: " + res.data['CC'] + "</li>");
            }
            if (res.data['CID']) {
              $('#dpfVehicleInfo').append("<li class=\"block sm:list-item\">CID: " + res.data['CID'] + "</li>");
            }
          }
          $('#dpfSearchResultsSpinner').addClass('hidden');
        },
        error: function error(err) {
          console.error(err);
        }
      });
    } else {
      $('#dpfSearchResultsSpinner').addClass('hidden');
    }
  }

  // Use mousedown so that this fires *before* other click events.
  $(document).on("mousedown", function (e) {
    var $trigger1 = $("#dpfSearchFormWrapper");
    var $trigger2 = $("#dpfVehicleFilterPanel");
    if (!e.target.closest("li.dpf-show-search-form") && !e.target.classList.contains("dpf-show-search-form") && $trigger1 !== e.target && !$trigger1.has(e.target).length) {
      if ($("#dpfHeaderSearch").hasClass("search-visible")) {
        enableScroll();
      }
      $("#dpfHeaderSearch").removeClass("search-visible");
      dpfHeaderSearchOffset();

      // Query by dropdown-open to make sure that we do not slideToggle on unopened dropdowns.
      // That messes them up.
      $(".dpf-form__fieldtype-select.dropdown-open").each(function () {
        $(this).removeClass("dropdown-open");
        $(this).children(".dpf-form__dropdown-wrapper").removeClass("open");
        if ($(this).data("timeout-id")) {
          clearInterval($(this).data("timeout-id"));
          $(this).find(".dpf-form__active-value span").removeClass("dpf-keyboard-indicator");
        }
        if ($(this).children(".dpf-form__active-value").children("span").text() === "") {
          $(this).children("label").removeClass("in-focus");
        }
      });
    } else {
      // If we did click inside the search form, we need to close
      // any open dropdown.
      $('.dpf-form__dropdown-wrapper').each(function () {
        if ($(this).hasClass('open') && !e.target.classList.contains('dpf-form__active-value') &&
        // opening dropdown
        !e.target.parentNode.classList.contains('dpf-form__active-value') &&
        // opening dropdown with span
        !e.target.parentNode.classList.contains('dpf-form__dropdown-item') &&
        // clicking on text
        !e.target.parentNode.classList.contains('dpf-form__dropdown') &&
        // clicking outside text
        !e.target.classList.contains('dpf-form__dropdown-wrapper') // clicking on scroll bar
        ) {
          $(this).parent().removeClass("dropdown-open");
          $(this).toggleClass('open');
          if ($(this).parent().data("timeout-id")) {
            clearInterval($(this).parent().data("timeout-id"));
            $(this).parent().find(".dpf-form__active-value span").removeClass("dpf-keyboard-indicator");
          }
          if ($(this).parent().find(".dpf-form__active-value span").text().trim() === "") {
            $(this).siblings("label").removeClass("in-focus");
          }
        }
      });
    }
    if (e.target.id !== "dpfFilterOpen" && $trigger2.hasClass("translate-x-full") && $trigger2 !== e.target && !$trigger2.has(e.target).length) {
      if ($trigger2.hasClass("translate-x-full")) {
        enableScroll();
      }
      $trigger2.removeClass("translate-x-full");
      $('.dpf-mobile-filter-overlay').addClass('hidden');
    }
  });
  $(document).on("mousemove", "li.dpf-form__dropdown-item", function () {
    $("li.dpf-form__dropdown-item").removeClass("dpf-dropdown-selected");
    $(this).addClass("dpf-dropdown-selected");
  });
  $(document).on("mouseout", "li.dpf-form__dropdown-item", function () {
    $(this).removeClass("dpf-dropdown-selected");
  });
  function takeOverFindMyPart() {
    // Look for menu items with the CSS class 'dpf-show-search-form' on either li or a elements
    // This works with any language and allows admin to position the menu item anywhere
    var links = $('div.dpf-show-search-form a, li.dpf-show-search-form a, a.dpf-show-search-form');
    if (window.location.href.includes("installation-guides")) {
      links.attr("href", "/#find-my-part");
    } else {
      links.attr('href', '#');
    }
  }

  // not getting called currently
  function handleScroll() {
    $("#dpfHeaderSearch").removeClass("search-visible");
    dpfHeaderSearchOffset();
    $(".dpf-form__fieldtype-select").removeClass("dropdown-open");
    $(".dpf-form__fieldtype-select").children(".dpf-form__dropdown-wrapper").removeClass("open").removeAttr("style");
    if ($(".dpf-form__fieldtype-select").data("timeout-id")) {
      clearInterval($(".dpf-form__fieldtype-select").data("timeout-id"));
      $(".dpf-form__fieldtype-select").find(".dpf-form__active-value span").removeClass("dpf-keyboard-indicator");
    }
  }
  function dpfPutSearchInHeader() {
    $("#dpfHeaderSearch").insertAfter("header");
    if ($("#dpfHeaderSearch").is(":visible")) {
      $(window).scroll(handleScroll);
      $(".dpf-tablink").on("click", function () {
        var selectedTab = $(this).text();
        $(".dpf-search-header-nav-active").text(selectedTab);
        $(this).parents(".dpf-tab-nav").removeClass("open").slideUp();
      });
    } else {
      $(".dpf-tab-nav").removeClass("open");
    }
  }

  // Opening, closing dropdown by clicking on it
  $(document).on('click', 'fieldset:not(.disabled) .dpf-form__active-value', function () {
    dpfOpenDropdown($(this));
  });
  function dpfOpenDropdown(clicked) {
    $('.dpf-form__active-value').each(function () {
      if ($(this).siblings('.dpf-form__dropdown-wrapper').hasClass('open') && !$(this).is(clicked)) {
        $(this).siblings('.dpf-form__dropdown-wrapper').toggleClass('open');
        $(this).parent().removeClass("dropdown-open");
      }
    });
    var label = clicked.parents('.dpf-form__fieldtype-select').toggleClass('dropdown-open').find('.dpf-form__label');
    label.toggleClass('black');
    if (!clicked.parent().hasClass("dpf-form__field-multiple")) {
      label.addClass('in-focus');
    }
    clicked.siblings('.dpf-form__dropdown-wrapper').toggleClass('open');
    $(".dpf-form__fieldtype-select").each(function () {
      if ($(this).data("timeout-id")) {
        clearInterval($(this).data("timeout-id"));
        $(this).find(".dpf-form__active-value span").removeClass("dpf-keyboard-indicator");
      }
    });
    if (clicked.parent().hasClass("dropdown-open")) {
      if (!clicked.parent().hasClass("dpf-form__field-multiple") && clicked.children("span").text().trim() === clicked.siblings("input").val()) {
        clicked.siblings(".dpf-form__dropdown-wrapper").find("li.dpf-form__dropdown-item.hidden").removeClass("hidden");
      }
      $(clicked.siblings(".dpf-form__dropdown-wrapper").find("li.dpf-form__dropdown-item")[0]).addClass("dpf-dropdown-selected");
    }
    if (!clicked.parent().hasClass("dropdown-open") && clicked.children("span").text().trim() === "") {
      clicked.siblings("label").removeClass("in-focus");
    }
    if (!clicked.parent().hasClass("dpf-form__field-multiple") && clicked.parent().hasClass("dropdown-open")) {
      var textNode = clicked.children("span");
      if ($(window).innerWidth() >= navBreak) {
        clicked.parent().data("timeout-id", setInterval(function () {
          textNode.toggleClass("dpf-keyboard-indicator");
        }, 500));
      }
    }
  }

  /**
   * Reset a specific fieldset and its subsequent fields
   * This is used when we need to clear a fieldset and all fields that come after it
   */
  function dpfVehicleSearchReset(fieldWrap) {
    // Clear the current fieldset
    clearFieldset(fieldWrap);

    // Clear all subsequent fieldsets
    clearSubsequentFieldsets(fieldWrap);

    // Handle special cases for engine/trim logic
    handleEngineTrimLogic();
  }

  /**
   * Clear a single fieldset
   */
  function clearFieldset(fieldWrap) {
    fieldWrap.find('.dpf-form__active-value').children('span').text('');
    fieldWrap.find('.dpf-form__input-selected').val('');
    fieldWrap.find('label').removeClass('in-focus');
    fieldWrap.removeClass('disabled');
  }

  /**
   * Clear all subsequent fieldsets after the given fieldset
   */
  function clearSubsequentFieldsets(fieldWrap) {
    fieldWrap.nextAll().find('.dpf-form__active-value').children('span').text('');
    fieldWrap.nextAll().find('.dpf-form__input-selected').val('');
    fieldWrap.nextAll().find('label').removeClass('in-focus');
    fieldWrap.nextAll().addClass('disabled');
  }

  /**
   * Handle special logic for engine and trim field visibility
   * This maintains the original behavior for engine/trim dependencies
   */
  function handleEngineTrimLogic() {
    if ($('#dpfVehicleEngine').val().length <= 0) {
      $('#dpfVehicleEngineFieldset').addClass('disabled');
      $('#dpfVehicleTrimFieldset').addClass('hidden disabled');
    } else {
      if ($('#dpfVehicleTrim').val().length <= 0) {
        $('#dpfVehicleTrimFieldset').addClass('hidden disabled');
      }
    }
  }
  function loadYears() {
    return loadDropdown({
      action: 'dpf_opticat_years',
      nonce: dpf.nonce,
      payload: {},
      fieldsetId: 'dpfVehicleYearFieldset',
      itemsSelector: '#dpfVehicleYearDropdownItems',
      handlePrev: {
        resHtml: null,
        nameSpan: '#dpfVehicleYearSpan',
        input: '#dpfVehicleYear'
      },
      openDropdownOnLoad: false
    });
  }

  // will not try if year is not passed
  function loadMakes(year) {
    var openDropdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return new Promise(function (resolve) {
      if (!year) return resolve();
      loadDropdown({
        action: 'dpf_opticat_makes',
        nonce: dpf.nonce,
        payload: {
          year: year
        },
        fieldsetId: 'dpfVehicleMakeFieldset',
        itemsSelector: '#dpfVehicleMakeDropdownItems',
        handlePrev: {
          resHtml: null,
          nameSpan: '#dpfVehicleMakeSpan',
          input: '#dpfVehicleMake'
        },
        openDropdownOnLoad: openDropdown
      }).then(resolve);
    });
  }

  // will not try unless both year and makeId are passed
  function loadModels(year, makeId) {
    var openDropdown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return new Promise(function (resolve) {
      if (!year || !makeId) return resolve();
      loadDropdown({
        action: 'dpf_opticat_models',
        nonce: dpf.nonce,
        payload: {
          year: year,
          makeId: makeId
        },
        fieldsetId: 'dpfVehicleModelFieldset',
        itemsSelector: '#dpfVehicleModelDropdownItems',
        handlePrev: {
          resHtml: null,
          nameSpan: '#dpfVehicleModelNameSpan',
          input: '#dpfVehicleBaseVehicle'
        },
        openDropdownOnLoad: openDropdown
      }).then(resolve);
    });
  }
  function loadEngines(baseVehicleId) {
    var openDropdown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return new Promise(function (resolve) {
      if (!baseVehicleId) return resolve();
      showLoadingIndicator('dpfVehicleEngineFieldset');
      $.ajax({
        type: 'POST',
        url: dpf.ajax_url,
        data: {
          action: 'dpf_opticat_engines',
          nonce: dpf.nonce,
          baseVehicleId: baseVehicleId
        },
        success: function success(res) {
          if (res.length === 0) {
            // No engines needed; keep engine field hidden/disabled and proceed to trims
            $('#dpfVehicleEngineFieldset').addClass('hidden disabled');
            $('#dpfVehicleEngine').val('');
            $('#dpfVehicleEngineNameSpan').text('');
            hideLoadingIndicator('dpfVehicleEngineFieldset');
            loadTrims(null, baseVehicleId).then(resolve);
          } else {
            $('#dpfVehicleEngineDropdownItems').html(res);
            $('#dpfVehicleEngineFieldset').removeClass('hidden disabled');
            handlePreviousValue($(res), $('#dpfVehicleEngineNameSpan'), $('#dpfVehicleEngine'));
            if (openDropdown) dpfOpenDropdown($('#dpfVehicleEngineFieldset').find('div.dpf-form__input'));
            hideLoadingIndicator('dpfVehicleEngineFieldset');
            resolve();
          }
        },
        error: function error(err) {
          console.error(err);
          hideLoadingIndicator('dpfVehicleEngineFieldset');
          resolve();
        }
      });
    });
  }
  function loadTrims(baseEngineId, baseVehicleId) {
    var openDropdown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return new Promise(function (resolve) {
      if (!baseVehicleId) return resolve();
      var payload = baseEngineId ? {
        baseVehicleId: baseVehicleId,
        baseEngineId: baseEngineId
      } : {
        baseVehicleId: baseVehicleId
      };
      showLoadingIndicator('dpfVehicleTrimFieldset');
      $.ajax({
        type: 'POST',
        url: dpf.ajax_url,
        data: Object.assign(payload, {
          action: 'dpf_opticat_trims',
          nonce: dpf.nonce
        }),
        success: function success(res) {
          if (res.length === 0) {
            // No trims needed; keep trim field hidden/disabled and proceed to part types
            $('#dpfVehicleTrimFieldset').addClass('hidden disabled');
            $('#dpfVehicleTrim').val('');
            $('#dpfVehicleTrimSpan').text('');
            hideLoadingIndicator('dpfVehicleTrimFieldset');
            loadPartTypes(null, baseVehicleId, baseEngineId, true).then(resolve);
          } else {
            $('#dpfVehicleTrimDropdownItems').html(res);
            $('#dpfVehicleTrimFieldset').removeClass('hidden disabled');
            handlePreviousValue($(res), $('#dpfVehicleTrimSpan'), $('#dpfVehicleTrim'));
            if (openDropdown) dpfOpenDropdown($('#dpfVehicleTrimFieldset').find('div.dpf-form__input'));
            hideLoadingIndicator('dpfVehicleTrimFieldset');
            resolve();
          }
        },
        error: function error(err) {
          console.error(err);
          hideLoadingIndicator('dpfVehicleTrimFieldset');
          resolve();
        }
      });
    });
  }
  function loadPartTypes(trimId, baseVehicleId, baseEngineId) {
    var pageLoad = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var openDropdown = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    return new Promise(function (resolve) {
      if (!baseVehicleId) return resolve();
      showLoadingIndicator('dpfVehiclePartTypesFieldset');
      var params = groupParamsByKey(new URLSearchParams(window.location.search));
      var availablePartTypes = params['dpfVehicleAvailablePartTypes[]'];
      var selectedPartTypes = params['dpfVehiclePartTypes[]'] || [];
      var extraData = {
        baseVehicleId: baseVehicleId
      };
      if (trimId) extraData.trimId = trimId;
      if (baseEngineId) extraData.baseEngineId = baseEngineId;
      if (pageLoad) extraData.partTypes = selectedPartTypes;else dpfVehicleSearchReset($('#dpfVehiclePartTypesFieldset'));
      $.ajax({
        type: 'POST',
        url: dpf.ajax_url,
        data: Object.assign(extraData, {
          action: 'dpf_opticat_part_types',
          nonce: dpf.nonce
        }),
        success: function success(res) {
          $('#dpfVehiclePartTypeDropdownItems').html("<li class=\"dpf-form__dropdown-item\">\n\t\t\t\t\t\t\t<input type=\"checkbox\" class=\"cursor-pointer\" id=\"dpfPartTypeSelectAll\">\n\t\t\t\t\t\t\t<span>Select all</span>\n\t\t\t\t\t\t</li>" + res);

          // If we're on page load and have pre-selected part types, check the appropriate checkboxes
          if (pageLoad && availablePartTypes) {
            // Check if "Select All" should be checked by comparing selected vs available part types
            if (selectedPartTypes.length === 0 || Object.keys(availablePartTypes).length === selectedPartTypes.length) {
              $('#dpfVehiclePartTypeDropdownItems input[type="checkbox"]').prop('checked', true);
            }

            // Check the checkboxes for pre-selected part types
            selectedPartTypes.forEach(function (partTypeId) {
              var checkbox = $("#dpfVehiclePartTypeDropdownItems input[value=\"" + partTypeId + "\"]");
              if (checkbox.length > 0) {
                checkbox.prop('checked', true);
              }
            });

            // Update the display text to show what's selected
            if (selectedPartTypes.length === 1) {
              $('#dpfVehiclePartTypesFieldset .dpf-form__active-value span').text(selectedPartTypes[0]);
            } else if (selectedPartTypes.length > 1) {
              $('#dpfVehiclePartTypesFieldset .dpf-form__active-value span').text('Multiple selected');
            }

            // Add focus to the label to show it's active
            $('#dpfVehiclePartTypesFieldset .dpf-form__label').addClass('in-focus');
          }
          $('#dpfVehiclePartTypesFieldset').removeClass('hidden disabled');
          submitAvailable();
          if (openDropdown) dpfOpenDropdown($('#dpfVehiclePartTypesFieldset').find('div.dpf-form__input'));
          hideLoadingIndicator('dpfVehiclePartTypesFieldset');
          resolve();
        },
        error: function error(err) {
          console.error(err);
          hideLoadingIndicator('dpfVehiclePartTypesFieldset');
          resolve();
        }
      });
    });
  }
  function dpfVehicleChangeValue(input, val, name) {
    input.val(val);

    // Clear part type checkboxes
    $('#dpfVehiclePartTypeDropdownItems').children('li').children('input.cursor-pointer').attr('checked', false);

    // Check if Vehicle Type is auto-selected (hidden due to admin config)
    var $vehicleTypeFieldset = $('#dpfVehicleTypeFieldset');
    var vehicleTypeAutoSelected = $vehicleTypeFieldset.hasClass('hidden') && $('#dpfVehicleType').val();

    // Determine which fieldset to clear from based on the input ID
    var currentFieldset = '';
    var excludeFieldsets = [];

    // If Vehicle Type is auto-selected, exclude Search By fieldset from clearing
    if (vehicleTypeAutoSelected) {
      excludeFieldsets.push('dpfSearchByFieldset');
    }
    if (input.attr("id") === "dpfVehicleYear") {
      currentFieldset = 'dpfVehicleYearFieldset';
      // Clear all subsequent fields and load makes
      clearSubsequentFields(currentFieldset, excludeFieldsets);
      loadMakes(val);
      // Clear other search types
      partNumberInput().val("");
      crossReferenceInput().val("");
      vinInput().val("");
    } else if (input.attr("id") === "dpfVehicleMake") {
      currentFieldset = 'dpfVehicleMakeFieldset';
      $("#dpfVehicleMakeName").val(name);
      // Clear all subsequent fields and load models
      clearSubsequentFields(currentFieldset, excludeFieldsets);
      loadModels($("#dpfVehicleYear").val(), val);
    } else if (input.attr("id") === "dpfVehicleBaseVehicle") {
      currentFieldset = 'dpfVehicleModelFieldset';
      $("#dpfVehicleModelName").val(name);
      // Clear all subsequent fields and load engines
      clearSubsequentFields(currentFieldset, excludeFieldsets);
      loadEngines(val);
    } else if (input.attr("id") === "dpfVehicleEngine") {
      currentFieldset = 'dpfVehicleEngineFieldset';
      $("#dpfVehicleEngineName").val(name);
      // Clear all subsequent fields and load trims
      clearSubsequentFields(currentFieldset, excludeFieldsets);
      loadTrims(val, $("#dpfVehicleBaseVehicle").val());
    } else if (input.attr("id") === "dpfVehicleTrim") {
      currentFieldset = 'dpfVehicleTrimFieldset';
      $("#dpfVehicleTrimName").val(name);
      // Clear all subsequent fields and load part types
      clearSubsequentFields(currentFieldset, excludeFieldsets);
      loadPartTypes(val, $("#dpfVehicleBaseVehicle").val(), $("#dpfVehicleEngine").val(), true);
    }

    // Show Clear Filters button when form has data
    showClearFiltersButton();
  }
  function dpfDropdownClicked(clicked) {
    var $form = clicked.parents('.dpf-form');
    var $fieldWrap = clicked.parents('.dpf-form__field-wrapper');
    var $field = clicked.parents('.dpf-form__fieldtype-select');
    var selectedValue = clicked.attr('data-value');
    var selectedDisplay = clicked.text();
    if (!$field.hasClass("dpf-form__field-multiple")) {
      $field.find("li.dpf-form__dropdown-item").removeClass("dpf-dropdown-selected");

      // Remove the underlines because we have chosen.
      $field.find("li.dpf-form__dropdown-item").each(function () {
        $(this).html($(this).text().replace("&nbsp;", " "));
      });
    }

    // not used, but helpful to know how to find it
    // var currentValue = $field.find('.dpf-form__input-selected').val()

    // selectedValue being undefined can be our "Select All"

    $fieldWrap.find('.dpf-form__label').addClass('in-focus').removeClass('black');
    if ($field.hasClass('dpf-form__field-multiple')) {
      var input = clicked.children('input:visible').first();
      var newValue = !input.is(':checked');

      // Process our current input.
      input.prop('checked', newValue);

      // Post-process select all.
      if (clicked.attr('data-value') === undefined) {
        $field.children('.dpf-form__dropdown-wrapper').children('.dpf-form__dropdown').children('.dpf-form__dropdown-item').children('input:visible').prop('checked', newValue);
      } else {
        // Make sure select all is not checked.
        $field.children('.dpf-form__dropdown-wrapper').children('.dpf-form__dropdown').children('.dpf-form__dropdown-item').children('input:visible').first().prop('checked', false);
      }

      // Set our name appropriately.
      var checkedboxes = $field.children('.dpf-form__dropdown-wrapper').children('.dpf-form__dropdown').children('.dpf-form__dropdown-item').children('input:checked:visible');
      if (checkedboxes.length === 1) {
        $field.find('.dpf-form__active-value').children('span').text(checkedboxes.closest('.dpf-form__dropdown-item').first().text());
      } else if (checkedboxes.length > 1) {
        $field.find('.dpf-form__active-value').children('span').text('Multiple selected');
      } else {
        $field.find('.dpf-form__label').addClass('black').removeClass('in-focus');
        $field.find('.dpf-form__active-value').children('span').text('');
      }
    } else {
      $field.removeClass('dropdown-open');
      $field.find('.dpf-form__dropdown-wrapper').removeClass('open').slideUp();
      if ($field.data("timeout-id")) {
        clearInterval($field.data("timeout-id"));
        $field.find(".dpf-form__active-value span").removeClass("dpf-keyboard-indicator");
      }
      $field.find('.dpf-form__active-value').children('span').text(selectedDisplay);
      dpfVehicleChangeValue($field.find('.dpf-form__input-selected'), selectedValue, selectedDisplay);
    }
    if (clicked.data('field') == 'year') {
      $('.dpf-form__separator, .dpf-form__separator + fieldset').hide();
      $('.dpf-form__clear-filters').removeClass('hidden');
      if ($(window).innerWidth() >= navBreak) {
        $form.addClass('tablet-all-drops');
      } else {
        $form.removeClass('tablet-all-drops');
      }
    }
    // this shows how to control the submit button via a non-multi select field
    // if ( $('#dpfVehicleTrim').val() !== '' ) {
    // 	$form.find('button[type=submit]').attr('disabled', false);
    // }

    // Exclusions
    if ($fieldWrap.attr('id') === 'dpfHdProductFieldset' && selectedValue == 'ac-compressor') return;
    submitAvailable();

    // Show Clear Filters button when form has data
    showClearFiltersButton();
  }
  function handlePreviousValue(res, nameSpan, input) {
    // Handle the input existing.
    if (input.val()) {
      var chosenSibling = res.filter("li[data-value='" + input.val() + "']");
      if (chosenSibling.length > 0) {
        // Make sure our fieldset is available if all else is selected.
        input.closest(".dpf-form__field-wrapper").removeClass("disabled");
      } else {
        dpfVehicleSearchReset(input.closest(".dpf-form__field-wrapper"));
      }
    }

    // Handle only the name existing.
    if (nameSpan.text().length > 0 && !input.val()) {
      var _chosenSibling = res.filter("li:contains('" + $("#dpfVehicleModelNameSpan").text() + "')");
      if (_chosenSibling.length > 0) {
        dpfVehicleChangeValue(input, _chosenSibling.data("value"), _chosenSibling.text(), true);
      } else {
        dpfVehicleSearchReset(input.closest(".dpf-form__field-wrapper"));
      }
    }
  }
  function submitAvailable() {
    // Containers and field pairs by ID of required fields
    var requiredContainerField = [
    // ['dpfVehicleYearFieldset', 'dpfVehicleYear'], // We really shouldn't need these as only the last field in a set should trigger the submit button to be enabled
    // ['dpfVehicleMakeFieldset', 'dpfVehicleMake'],
    // ['dpfVehicleModelFieldset', 'dpfVehicleBaseVehicle'],
    // ['dpfVehicleEngineFieldset', 'dpfVehicleEngine'],
    // ['dpfVehicleTrimFieldset', 'dpfVehicleTrim'],
    ['dpfVehiclePartTypesFieldset', 'dpfVehiclePartTypes'],
    // YMM search
    ['dpfHdAlternatorAmpsFieldset', 'dpfHdAlternatorAmps'],
    // Alternators
    ['dpfHdStarterPowerRatingFieldset', 'dpfHdStarterPowerRating'] // Starters
    ];

    // If any these are visible and have a value, then the submit button is enabled
    var isEnabled = requiredContainerField.some(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        container = _ref3[0],
        field = _ref3[1];
      return !$('#' + container).hasClass('hidden') && $('#' + field).val() ||
      // Single-select dropdown
      !$('#' + container).hasClass('hidden') && $('.dpf-form__dropdown-item').children('input[type=checkbox][name="' + field + '[]"]:checked').length > 0; // Multi-select dropdown
    });

    submitButton().attr('disabled', !isEnabled);
  }
  $(document).on('click', '.dpf-form__dropdown-item', function () {
    dpfDropdownClicked($(this));
  });
  $(document).on('click', '.dpf-form__dropdown-item > input', function () {
    dpfDropdownClicked($(this).parent());
  });
  $(document).on("click", "#dpfClearFilters", function () {
    // Hide the clear filters button
    $(this).parents(".dpf-form__clear-filters").addClass("hidden");

    // Reset the entire form to initial state
    resetFormToInitialState();
  });

  // normal form things floating labels
  var inputs = '.dpf-form input:not(.dpf-form__select-input):not([type="radio"]):not([type="checkbox"]):not([type="submit"]):not([type="button"]):not([type="image"]):not([type="file"]):visible, .dpf-form textarea:visible';
  $(document).on("focus", inputs, function () {
    $(this).parents(".dpf-form__field").find(".dpf-form__input").addClass("in-focus");
    $(this).parents(".dpf-form__field").find("label:first").addClass("in-focus font-weight-bold");
  });
  $(document).on('blur', inputs, function () {
    $(this).parents('.dpf-form__field').find('.dpf-form__input').removeClass('in-focus');
    $(this).parents('.dpf-form__field').find('label:first').removeClass('in-focus font-weight-bold');
    if ($(this).val().length > 0) {
      $(this).parents('.dpf-form__field').find('label:first').addClass('in-focus');
    } else {
      $(this).parents('.dpf-form__field').find('label:first').removeClass('in-focus');
    }
  });

  // todo whenever this is called, should also update the current page query string
  // this is on hold due to upcoming interface changes
  function updatePartsList() {
    var params = groupParamsByKey(new URLSearchParams(window.location.search));

    // Clean up any undefined, null, empty string, or 'Any' parameters to avoid sending invalid data
    Object.keys(params).forEach(function (key) {
      if (params[key] === undefined || params[key] === null || params[key] === '' || params[key] === 'Any') {
        delete params[key];
      }
    });
    var filters = [];

    // move this and the same code in `setViewAllFilter` into shared function?
    var parents = $(window).innerWidth() < navBreak ? $('.dpfFilterMainSelect').children('input') : filterSelection().children('div').children('input');
    var allChildren = $(window).innerWidth() < navBreak ? $('.dpfFilterPage').children('div').children('input') : filterSelection().children('div').children('div').children('input');
    parents.each(function () {
      if ($(this).is(":checked")) {
        filters.push($(this).data("category-name"));
      }
    });
    allChildren.each(function () {
      if ($(this).is(":checked")) {
        filters.push($(this).data("part-type-id"));
      }
    });
    $("#dpfVehicleSearchList").html("");
    $("#dpfHdProductAvailable").text("?? Products Available");
    showFormLoading();
    $("#dpfMaxShown").addClass("hidden");
    $.ajax({
      type: "POST",
      url: dpf.ajax_url,
      // need to include all of the names etc. because otherwise the query-string navigation
      // will break
      // (yes, cleaning up query strings is on the wish list)
      data: {
        action: "dpf_opticat_parts",
        nonce: dpf.nonce,
        dpfVehicleType: params.dpfVehicleType,
        dpfSearchBy: params.dpfSearchBy,
        dpfHdPartTypeIds: params.dpfHdPartTypeIds,
        dpfHdProduct: params.dpfHdProduct,
        dpfHdAlternatorFamily: params.dpfHdAlternatorFamily,
        dpfHdAlternatorVoltage: params.dpfHdAlternatorVoltage,
        dpfHdAlternatorVoltageUomCodes: params.dpfHdAlternatorVoltageUomCodes,
        dpfHdAlternatorAmps: params.dpfHdAlternatorAmps,
        dpfHdAlternatorAmpsUomCodes: params.dpfHdAlternatorAmpsUomCodes,
        dpfHdStarterFamily: params.dpfHdStarterFamily,
        dpfHdStarterVoltage: params.dpfHdStarterVoltage,
        dpfHdStarterVoltageUomCodes: params.dpfHdStarterVoltageUomCodes,
        dpfHdStarterPowerRating: params.dpfHdStarterPowerRating,
        dpfHdStarterPowerRatingUomCodes: params.dpfHdStarterPowerRatingUomCodes,
        dpfVehicleBaseVehicle: params.dpfVehicleBaseVehicle,
        dpfVehiclePartNum: params.dpfVehiclePartNum,
        dpfVehicleCrossRef: params.dpfVehicleCrossRef,
        dpfVehicleEngine: params.dpfVehicleEngine,
        dpfVehicleEngineName: params.dpfVehicleEngineName,
        dpfVehicleTrim: params.dpfVehicleTrim,
        dpfVehicleTrimName: params.dpfVehicleTrimName,
        dpfVehicleYear: params.dpfVehicleYear,
        dpfVehicleMake: params.dpfVehicleMake,
        dpfVehicleMakeName: params.dpfVehicleMakeName,
        dpfVehicleModelName: params.dpfVehicleModelName,
        dpfVehicleAvailablePartTypes: params['dpfVehicleAvailablePartTypes[]'],
        dpfVehiclePartTypes: filters
      },
      success: function success(res) {
        $("#dpfVehicleSearchList").html(res.data.html);

        // Heavy-duty category filters are derived from the results. Populate
        // them on the initial unfiltered load so they match what is shown.
        if (params.dpfVehicleType === "heavy-duty" && filters.length === 0) {
          if (res.data.filters !== undefined) {
            $("#dpfFilterSelection").html(res.data.filters);
          }
          if (res.data.filtersMobile !== undefined) {
            $("#dpfMobileFilterGroups").html(res.data.filtersMobile);
          }
        }
        if (res.data.count === 0) {
          $("#dpfNoParts").removeClass("hidden");
        } else {
          $("#dpfNoParts").addClass("hidden");
          $('.dpf-product-count').removeClass('hidden');
        }
        $("#dpfHdProductAvailable").text(res.data.count + " Product" + (res.data.count === 1 ? '' : 's') + " Available");
        hideFormLoading();
        if (res.data.maxShown) {
          $("#dpfMaxShown").removeClass("hidden");
        }
      },
      error: function error(err) {
        // When we get an error, we will still receive a part count.
        // So we can fill that in still.
        // unfortunate duplication of string
        $("#dpfHdProductAvailable").text('0 Products Available');
        $("#dpfNoParts").removeClass("hidden");
        hideFormLoading();
      }
    });
  }
  $(document).on('click', '.dpfPartTypeFilterParent', function () {
    $(this).parent().siblings('div:not(.dpfFilterViewAllCategory)').toggleClass('hidden');
    $(this).toggleClass('rotate');
    if ($(this).parent().siblings('div:not(.dpfFilterViewAllCategory)').hasClass('hidden')) {
      $(this).parent().siblings('div.dpfFilterViewAllCategory').addClass('hidden');
    } else {
      var categoryChildren = $(this).parent().siblings('div').children('input');
      if (categoryChildren.length !== categoryChildren.parent().children('input:checked').length) {
        $(this).parent().siblings('div.dpfFilterViewAllCategory').removeClass('hidden');
      } else {
        $(this).parent().siblings('div.dpfFilterViewAllCategory').addClass('hidden');
      }
    }
  });
  $(document).on('click', '.dpfPartTypeFilterType', function () {
    // Carry over checkbox from desktop to mobile and vice versa.
    var totalInputs = $("input[data-part-type-id=\"" + $(this).data('part-type-id') + "\"]");
    totalInputs.prop("checked", $(this).is(":checked"));
    var category = totalInputs.parent().parent().children('input.dpfPartTypeInputParent');
    var page = totalInputs.parent().parent();
    var mobileCategory = totalInputs.parent().parent().parent().children('div').children("input[data-category-name=\"" + page.attr('data-category-name') + "\"]");

    // If we are now checked, we do not want our parent to be.
    // Otherwise, being checked means nothing.
    if (this.checked) {
      category.prop("checked", false);
      mobileCategory.prop("checked", false);
    }
    var categoryChildren = $(this).parent().parent().children('div').children('input');
    if (categoryChildren.length !== categoryChildren.parent().children('input:checked').length) {
      $(this).parent().siblings('div.dpfFilterViewAllCategory').removeClass('hidden');
    } else {
      $(this).parent().siblings('div.dpfFilterViewAllCategory').addClass('hidden');
    }
    $("#dpfFilterReset").removeClass("hidden");
    updatePartsList();
  });
  $(document).on('click', '.dpfFilterViewAllCategory', function () {
    $(this).siblings('div').children('input').prop('checked', true);
    $(this).addClass('hidden');
    updatePartsList();
  });

  // helper function from https://stackoverflow.com/a/52539264,
  // then customized to allow going one level deep with named params
  // to go further, we will need to move to recursion
  var groupParamsByKey = function groupParamsByKey(params) {
    return [].concat(_toConsumableArray(params.entries())).reduce(function (acc, tuple) {
      // adjust key name upon retrieving it
      // for each key:
      //   the named portion of the key will be extracted and handled on its own
      //     note that the above can only go one layer deep
      //   any array indexes will be removed. just send data in the right order
      var namedPortion = /\[[^\]]+\]/;
      var capturedNamedPortion = /(\[)[^\]]+(\])/;

      // removes the named portion and then removes any indexes
      var key = tuple[0].replace(namedPortion, '').replace(capturedNamedPortion, '$1$2');
      var val = tuple[1];
      var matches = tuple[0].match(namedPortion)?.map(function (m) {
        return m.replace('[', '').replace(']', '');
      });
      if (acc.hasOwnProperty(key)) {
        // matches: we are doing a named key
        // not matches: we are doing a standard situation of where the key
        // may possibly be an array or not
        if (matches) {
          if (acc[key][matches[0]]) {
            if (Array.isArray(acc[key][matches[0]])) {
              acc[key][matches[0]] = [].concat(_toConsumableArray(acc[key][matches[0]]), [val]);
            } else {
              acc[key][matches[0]] = [acc[key][matches[0]], val];
            }
          } else {
            // This should just be = val!
            // But the PHP code requires each entry to be an array,
            // so this makes life easier.
            acc[key][matches[0]] = [val];
          }
        } else {
          // if the current key is already an array, we'll add the value to it
          if (Array.isArray(acc[key])) {
            acc[key] = [].concat(_toConsumableArray(acc[key]), [val]);
          } else {
            // if it's not an array, but contains a value, we'll convert it into an array
            // and add the current value to it
            acc[key] = [acc[key], val];
          }
        }
      } else if (matches) {
        // This should just be = val!
        // But the PHP code requires each entry to be an array,
        // so this makes life easier.
        acc[key] = {};
        acc[key][matches[0]] = [val];
      } else if (key.includes("[]")) {
        // If we are an array value, we need to make sure that we always store an array.
        acc[key] = [val];
      } else {
        // plain assignment if no special case is present
        acc[key] = val;
      }
      return acc;
    }, {});
  };
  $(document).on('click', '#dpfFilterReset', function () {
    // move this and the same code in `setViewAllFilter` into shared function?
    var parents = filterSelection().children('div').children('input');
    var allChildren = filterSelection().children('div').children('div').children('input');
    var viewAll = filterSelection().children('div').children('div.dpfFilterViewAllCategory');
    var params = new URLSearchParams(window.location.search);
    var grouped = groupParamsByKey(params);
    var hasPartTypes = grouped['dpfVehiclePartTypes[]'] !== undefined;
    parents.each(function () {
      if (hasPartTypes && grouped['dpfVehiclePartTypes[]'].includes($(this).attr('data-category-name'))) {
        $(this).prop("checked", true);
      } else {
        $(this).prop("checked", false);
      }
    });
    allChildren.each(function () {
      $(this).prop("checked", false);
    });
    viewAll.each(function () {
      $(this).addClass("hidden");
    });
    updatePartsList();
  });
  $(document).on('click', '.dpfFilterMainSelect', function () {
    var categoryName = $(this).children('input').data('category-name');
    $(".dpfFilterPage[data-category-name=\"" + categoryName + "\"]").removeClass('hidden');
    $('.dpfFilterMainSelect').addClass('hidden');
  });

  // When filtering is open, we will disable scrolling outside of the filtering panel.
  $(document).on('click', '#dpfVehicleCloseFilters', function () {
    $('#dpfVehicleFilterPanel').removeClass('translate-x-full');
    $('.dpf-mobile-filter-overlay').addClass('hidden');
    enableScroll();
  });
  $(document).on('click', '#dpfFilterOpen', function () {
    $('#dpfVehicleFilterPanel').addClass('translate-x-full');
    $('#dpfVehicleFilterPanel').css('height', $(window).innerHeight() - $('header').height());
    $('.dpf-mobile-filter-overlay').removeClass('hidden');
    $('.dpf-mobile-filter-overlay').css('height', $(window).innerHeight() - $('header').height());
    disableScroll();
  });
  $(document).on('click', '.dpfFilterBack', function () {
    $('.dpfFilterPage').addClass('hidden');
    $('.dpfFilterMainSelect').removeClass('hidden');
  });

  // Accepts an img element within the gallery list and uses it to switch the gallery image.
  function switchGalleryImage(element) {
    if (element.attr("data-url")) {
      // CSS could certainly be used to maintain the width, but since we are already using JS
      // to switch the element, it is so easy to set width and height too ...
      galleryImage().html("<iframe src=\"" + element.attr("data-url") + "\" width=\"" + galleryImage().width() + "\" height=\"" + galleryImage().height() + "\"></iframe>");
    } else if (element.attr("data-big-src")) {
      galleryImage().html("<img src=\"" + element.attr("data-big-src") + "\" alt=\"" + element.attr("alt") + "\">");
    }
  }
  $(document).on('click', '.dpfGalleryImage', function () {
    switchGalleryImage($(this));
  });
  function updateGuidesList() {
    var params = groupParamsByKey(new URLSearchParams(window.location.search));

    // Clean up any undefined, null, empty string, or 'Any' parameters to avoid sending invalid data
    Object.keys(params).forEach(function (key) {
      if (params[key] === undefined || params[key] === null || params[key] === '' || params[key] === 'Any') {
        delete params[key];
      }
    });
    if (!params.dpfVehicleBaseVehicle && !params.dpfVehiclePartNum) {
      return;
    }
    $("#dpfInstallationGuideResults").html("");
    showFormLoading();
    $("#dpfGuideNone").addClass("hidden");
    $("#dpfGuideMaxShown").addClass("hidden");
    $("#dpfGuideFormContainer").removeClass("pb-20");
    $.ajax({
      url: dpf.ajax_url,
      type: "POST",
      data: {
        action: "dpf_opticat_guides",
        nonce: dpf.nonce,
        dpfVehicleType: params.dpfVehicleType,
        dpfVehicleBaseVehicle: params.dpfVehicleBaseVehicle,
        dpfVehiclePartNum: params.dpfVehiclePartNum,
        dpfVehicleCrossRef: params.dpfVehicleCrossRef,
        dpfVehicleEngine: params.dpfVehicleEngine,
        dpfVehicleTrim: params.dpfVehicleTrim,
        dpfVehiclePartTypes: params['dpfVehiclePartTypes[]'],
        dpfHdPartTypeIds: params['dpfHdPartTypeIds[]'],
        dpfHdAlternatorFamily: params.dpfHdAlternatorFamily,
        dpfHdAlternatorVoltage: params.dpfHdAlternatorVoltage,
        dpfHdAlternatorVoltageUomCodes: params['dpfHdAlternatorVoltageUomCodes[]'],
        dpfHdAlternatorAmps: params.dpfHdAlternatorAmps,
        dpfHdAlternatorAmpsUomCodes: params['dpfHdAlternatorAmpsUomCodes[]'],
        dpfHdStarterFamily: params.dpfHdStarterFamily,
        dpfHdStarterVoltage: params.dpfHdStarterVoltage,
        dpfHdStarterVoltageUomCodes: params['dpfHdStarterVoltageUomCodes[]'],
        dpfHdStarterPowerRating: params.dpfHdStarterPowerRating,
        dpfHdStarterPowerRatingUomCodes: params['dpfHdStarterPowerRatingUomCodes[]']
      },
      success: function success(response) {
        $('#dpfInstallationGuideResults').html(response.data.html);
        hideFormLoading();
        if (!response.data.html) {
          $("#dpfGuideNone").removeClass("hidden");
        }
        if (response.data.html && response.data.maxShown) {
          $("#dpfGuideMaxShown").removeClass("hidden");
        }
      },
      error: function error(e) {
        console.error(e);
        hideFormLoading();
      }
    });
  }
  function getHiddenStop(choices) {
    return new Promise(function (resolve) {
      choices.each(function () {
        if (!$(this).hasClass('hidden')) {
          resolve($(this).index() - 1);
        }
      });
    });
  }

  // function getGalleryPageSize(clicked) {
  // 	return mobile ? 2 : 6;
  // }

  $(document).on('click', '.dpfPartImageUp', function () {
    var pageSize = 6;
    var choices = galleryImage().parent().siblings('ul').children('li.dpf-img-wrap');
    getHiddenStop(choices).then(function (hiddenStop) {
      if (hiddenStop === 0) {
        for (var i = 0; i < pageSize; i++) {
          $(choices[i]).addClass('hidden');
        }
        var remainder = choices.length % pageSize == 0 ? pageSize : choices.length % pageSize;
        for (var _i = choices.length - 1; _i > choices.length - 1 - remainder; _i--) {
          if (_i >= 0) {
            $(choices[_i]).removeClass('hidden');
          }
        }
      } else {
        for (var _i2 = hiddenStop; _i2 < hiddenStop + pageSize; _i2++) {
          $(choices[_i2]).addClass('hidden');
        }
        for (var _i3 = hiddenStop - 1; _i3 > hiddenStop - 1 - pageSize; _i3--) {
          if (_i3 >= 0) {
            $(choices[_i3]).removeClass('hidden');
          }
        }
      }
    });
  });
  $(document).on('click', '.dpfPartImageDown', function () {
    var pageSize = getGalleryPageSize($(this));
    var choices = galleryImage().parent().siblings('ul').children('li.dpf-img-wrap');
    getHiddenStop(choices).then(function (hiddenStop) {
      if (hiddenStop > 0 && hiddenStop >= choices.length - pageSize) {
        for (var i = 0; i < pageSize; i++) {
          $(choices[i]).removeClass('hidden');
        }
        for (var _i4 = hiddenStop; _i4 < hiddenStop + pageSize; _i4++) {
          if (_i4 < choices.length) {
            $(choices[_i4]).addClass('hidden');
          }
        }
      } else {
        for (var _i5 = hiddenStop; _i5 < hiddenStop + pageSize; _i5++) {
          $(choices[_i5]).addClass('hidden');
        }
        for (var _i6 = hiddenStop + pageSize; _i6 < hiddenStop + pageSize + pageSize; _i6++) {
          if (_i6 < choices.length) {
            $(choices[_i6]).removeClass('hidden');
          }
        }
      }
    });
  });
  function meetsCharacterRequirements() {
    return vinInput().val().length === VINLENGTH;
  }
  function turnOffPredefinedEvents() {
    submitButton().off();
  }
  function toggleVinSubmit() {
    submitButton().prop("disabled", !meetsCharacterRequirements());
  }
  function togglePartNumberSubmit() {
    submitButton().prop("disabled", partNumberInput().val().length < 3);
  }
  function toggleCrossRefSubmit() {
    submitButton().prop("disabled", crossReferenceInput().val().length < 3);
  }
  function fillFormWithVinData(data) {
    $("#dpfVehicleVin").val("");
    toggleVinSubmit();
    $(".dpf-form__clear-filters").removeClass("hidden");
    var paramMap = {
      "year": "dpfVehicleYear",
      "makeName": "dpfVehicleMakeName",
      "makeId": "dpfVehicleMake",
      "modelName": "dpfVehicleModelName",
      "baseVehicleId": "dpfVehicleBaseVehicle",
      "subModelId": "dpfVehicleTrim",
      "subModelName": "dpfVehicleTrimName",
      "EngineBaseId": "dpfVehicleEngine",
      "EngineName": "dpfVehicleEngineName"
    };
    var filterable = [];
    for (var entry in data) {
      if (data[entry].length === 1) {
        $("#" + paramMap[entry]).val(data[entry][0]);
        if (paramMap[entry].endsWith("Name") || paramMap[entry].endsWith("Year")) {
          $("#" + paramMap[entry] + "Span").text(data[entry][0]);
          $("#" + paramMap[entry]).siblings("label").addClass("in-focus");
        }
        $("#" + paramMap[entry] + "Fieldset").removeClass("hidden");
      } else {
        filterable.push(entry);
      }
    }
    initDropdowns(false).then(function (_) {
      filterable.forEach(function (f) {
        if (!paramMap[f].endsWith("Name")) {
          $("#" + paramMap[f] + "DropdownItems").children("li").each(function () {
            if (!data[f].includes($(this).data("value"))) {
              $(this).addClass("hidden");
            }
          });
        }
      });
    });
    $(".dpf-form__separator").addClass("hidden");
    $("#dpfPartNumberFieldset").addClass("hidden");
    $("#dpfCrossRefFieldset").addClass("hidden");
    $("#dpfVinFieldset").addClass("hidden");
  }

  /**
   * Filter out empty values from serialized form data
   * @param {Array} serializedArray - The serialized form data
   * @returns {Array} Filtered array with empty values removed
   */
  function filterEmptyValues(serializedArray) {
    return serializedArray.filter(function (item) {
      // Remove empty strings, null, undefined
      if (item.value === '' || item.value === null || item.value === undefined) {
        return false;
      }
      // Remove whitespace-only strings
      if (typeof item.value === 'string' && item.value.trim() === '') {
        return false;
      }
      // Remove specific empty values that might be set by the form
      if (item.value === '0' && (item.name.includes('dpfVehicle') || item.name.includes('dpfHd'))) {
        return false;
      }
      // Keep non-empty values
      return true;
    });
  }
  function handleFormSubmit(event) {
    event.preventDefault();

    // If we checked all available part types, we will check none of them.
    var serializedArray = $(this).serializeArray();
    if ($("#dpfVehiclePartTypeDropdownItems").children('li').first().children('input').is(':checked')) {
      serializedArray = serializedArray.filter(function (el) {
        return el.name !== 'dpfVehiclePartTypes[]';
      });
    }

    // Filter out empty values to keep URLs clean
    serializedArray = filterEmptyValues(serializedArray);
    var usingVin = vinInput().val().length > 0 && !vinInput().parent().hasClass('hidden');

    // If we are in installation guide mode, we will paste search results onto the page.
    if ($('#dpfVehicleAboveInfo').hasClass('hidden')) {
      if (usingVin) {
        if (meetsCharacterRequirements()) {
          showFormLoading();
          $.ajax({
            url: dpf.ajax_url,
            type: "POST",
            data: {
              action: "dpf_vin_search",
              vin: vinInput().val(),
              nonce: dpf.nonce
            },
            dataType: "JSON",
            success: function success(response) {
              var data = response.data;
              removeExistingError();
              fillFormWithVinData(data);
              hideFormLoading();
            },
            error: function error(_) {
              removeExistingError();
              hideFormLoading();
              // not sure if we have a way to propogate user errors
              container().prepend("<p id=\"error\">Could not find any installation guides for this vehicle</p>");
            }
          });
        } else {
          removeExistingError();
          // not sure if we have a way to propogate user errors
          container().prepend("<p id=\"error\">Length must be 17 characters</p>");
        }
      } else {
        var newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + $.param(serializedArray);
        window.history.pushState({
          path: newUrl
        }, "", newUrl);
        updateGuidesList();
      }
      return;
    }
    if (!usingVin) {
      // Save product context before redirecting to search results
      // This ensures we have all necessary data to populate HD Attribute search fields should the user change one of them
      var vehicleType = $('#dpfVehicleType').val();
      if (vehicleType === 'heavy-duty' && window.currentPartSet && window.currentPartSet.length > 0) {
        var productType = $('#dpfHdProduct').val();
        if (productType) {
          saveProductContextToStorage(window.currentPartSet, productType);
        }
      }
      var newSearch = $.param(serializedArray);
      window.location.href = '/part-finder-search-results?' + newSearch;
      return;
    }
    if (meetsCharacterRequirements()) {
      showFormLoading();
      $.ajax({
        url: dpf.ajax_url,
        type: "POST",
        data: {
          action: "dpf_vin_search",
          nonce: dpf.nonce,
          vin: vinInput().val()
        },
        dataType: "JSON",
        success: function success(response) {
          var data = response.data;
          removeExistingError();
          fillFormWithVinData(data);
          hideFormLoading();
        },
        error: function error(_) {
          removeExistingError();
          hideFormLoading();
          // not sure if we have a way to propogate user errors
          container().prepend("<p id=\"error\">Unable to locate that vehicle</p>");
        }
      });
    } else {
      removeExistingError();
      // not sure if we have a way to propogate user errors
      container().prepend("<p id=\"error\">Length must be 17 characters</p>");
    }
  }
  function partNumberInput() {
    return $("#dpfVehiclePartNum");
  }
  function crossReferenceInput() {
    return $("#dpfVehicleCrossRef");
  }
  function vinInput() {
    return $("#dpfVehicleVin");
  }
  function submitButton() {
    return $("#dpfVehicleSearchSubmit");
  }
  function form() {
    return $("#dpfVehicleSearchForm");
  }
  function container() {
    return $(".dpf-vehicle-search-form");
  }
  function filterSelection() {
    return $("#dpfFilterSelection");
  }
  function galleryImage() {
    return $("#dpfGalleryImage");
  }
  function removeExistingError() {
    $("#error").remove();
  }
  function disableScroll() {
    $('html').addClass('disable-scroll');
    $('body').addClass('disable-scroll');
  }
  function enableScroll() {
    $('html').removeClass('disable-scroll');
    $('body').removeClass('disable-scroll');
  }

  //! HD Product Search Update

  function initHdEnhancementsOnReady() {
    // Restore product context from localStorage if available
    var restoredParts = restoreProductContextFromStorage();
    if (restoredParts) {
      window.currentPartSet = restoredParts;
    }

    // Restore hidden field values from URL parameters
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('dpfHdPartTypeIds')) {
      $('#dpfHdPartTypeIds').val(urlParams.get('dpfHdPartTypeIds'));
    }

    // Populate dropdowns from local storage
    var dpfFormOptions = null;
    try {
      dpfFormOptions = JSON.parse(localStorage.getItem('dpfFormOptions'));
    } catch (e) {
      console.warn('Failed to parse dpfFormOptions from localStorage:', e);
      localStorage.removeItem('dpfFormOptions');
    }
    if (dpfFormOptions && Array.isArray(dpfFormOptions)) {
      // Populate fieldsets with dropdown options
      dpfFormOptions.forEach(function (dropdown) {
        if (!dropdown || !dropdown.fieldset || !dropdown.options || !Array.isArray(dropdown.options)) {
          return;
        }
        var $fieldset = $("#" + dropdown.fieldset);
        if (!$fieldset.length) {
          return;
        }
        $fieldset.find('.dpf-form__dropdown').append(dropdown.options.map(function (option) {
          return "<li class=\"dpf-form__dropdown-item\" data-value=\"" + option.value + "\">" + option.text + "</li>";
        }));
        var selectedValue = $fieldset.find('input').val();
        if (selectedValue) {
          var selectedOption = dropdown.options.find(function (option) {
            return option.value === selectedValue;
          });
          if (selectedOption) {
            var selectedText = selectedOption.text;
            setTimeout(function () {
              $fieldset.find('.dpf-form__input span').text(selectedText);
              $fieldset.find('.dpf-form__label').addClass('in-focus');
              $fieldset.removeClass('hidden disabled');
            }, 1000);
          }
        }
      });
    }

    // Show part/cross search field if it has a value
    if ($('#dpfVehiclePartNum').val()) {
      // TODO: I don't know what's causing the field to be disabled after I enable it but I need to move on so I'm just setting a timeout for now
      setTimeout(function () {
        $('#dpfPartNumberFieldset').find('.dpf-form__label').addClass('in-focus');
        $('#dpfPartNumberFieldset').removeClass('hidden disabled');
      }, 1000);
    }
    if ($('#dpfVehicleCrossRef').val()) {
      // TODO: I don't know what's causing the field to be disabled after I enable it but I need to move on so I'm just setting a timeout for now
      setTimeout(function () {
        $('#dpfCrossRefFieldset').find('.dpf-form__label').addClass('in-focus');
        $('#dpfCrossRefFieldset').removeClass('hidden disabled');
      }, 1000);
    }

    // Sidebar stuff
    var $dpfVehicleInfo = $('#dpfVehicleInfo');
    if ($dpfVehicleInfo) {
      var selectedProduct = $('#dpfHdProductSpan').text();
      if (selectedProduct) {
        // Set the product name in the sidebar
        var productFieldset = dpfFormOptions.find(function (option) {
          return option.fieldset === 'dpfHdProductFieldset';
        });
        if (productFieldset && productFieldset.options) {
          var selectedProductOption = productFieldset.options.find(function (option) {
            return option.value === selectedProduct.trim();
          });
          if (selectedProductOption) {
            var selectedProductText = selectedProductOption.text;
            $dpfVehicleInfo.append(selectedProductText);
            // Hide the filters
            // Using style attributes because the hidden class is being overwritten and adding !important to the helper file seemed risky
            $('#dpfFilterHeader').css('display', 'none');
            $('#dpfFilterSelection').css('display', 'none');
          }
        }
      }
    }
  }

  // Function to populate search by options based on vehicle type
  function populateSearchByOptions(selectedType) {
    var $searchByFieldset = $('#dpfSearchByFieldset');
    var $searchByDropdown = $('#dpfSearchByDropdownItems');

    // Define the search options for each vehicle type
    var vehicleTypeOptions = {
      'light-duty': [{
        value: 'ymm',
        text: dpf.strings.year_make_model || 'Year | Make | Model'
      }, {
        value: 'part',
        text: dpf.strings.denso_part_no || 'DENSO Part No.'
      }, {
        value: 'cross',
        text: dpf.strings.cross_reference || 'Cross Reference'
      }, {
        value: 'vin',
        text: dpf.strings.vin_search || 'VIN Search'
      }],
      'heavy-duty': [{
        value: 'part',
        text: dpf.strings.denso_part_no || 'DENSO Part No.'
      }, {
        value: 'cross',
        text: dpf.strings.cross_reference || 'Cross Reference'
      }, {
        value: 'attributes',
        text: dpf.strings.attributes || 'Attributes'
      }]
    };

    // Clear and hide subsequent fieldsets
    clearSubsequentFields('dpfVehicleTypeFieldset');

    // Enable the Search By fieldset
    $searchByFieldset.removeClass('disabled');

    // Clear previous options
    $searchByDropdown.empty();

    // Add new options based on vehicle type
    vehicleTypeOptions[selectedType].forEach(function (option) {
      $searchByDropdown.append("<li class=\"dpf-form__dropdown-item\" data-value=\"" + option.value + "\">" + option.text + "</li>");
    });

    // Add the options to the dpfFormOptions array for use on the results page
    saveFieldsetOptionsToStorage('dpfSearchByFieldset', vehicleTypeOptions[selectedType]);
  }
  function initDefaultSearchByOnReady() {
    var $searchTypeInput = $('#dpfVehicleType');
    var defaultSearchBy = $('#dpfVehicleSearchForm').data('default-search-by');
    if ($searchTypeInput.length && $searchTypeInput.val()) {
      var selectedType = $searchTypeInput.val();
      populateSearchByOptions(selectedType);

      // Check for default search by value from admin settings
      if (defaultSearchBy && defaultSearchBy !== '') {
        // Wait a moment for the dropdown to be populated, then select the default
        setTimeout(function () {
          var $defaultOption = $("#dpfSearchByDropdownItems .dpf-form__dropdown-item[data-value=\"" + defaultSearchBy + "\"]");
          if ($defaultOption.length) {
            // Trigger the click but prevent focus on subsequent fields
            window.dpfDefaultSearchBySelected = true;
            $defaultOption.click();
            setTimeout(function () {
              window.dpfDefaultSearchBySelected = false;
            }, 50);
          }
        }, 100);
      }
    } else if (defaultSearchBy && defaultSearchBy !== '') {
      // If vehicle type is auto-selected (hidden field), we need to determine the vehicle type
      // and populate the search by options, then apply the default
      var $vehicleTypeFieldset = $('#dpfVehicleTypeFieldset');
      if ($vehicleTypeFieldset.hasClass('hidden')) {
        // Vehicle type is auto-selected, determine which type based on available options
        var $lightDutyOption = $('#dpfVehicleTypeDropdownItems .dpf-form__dropdown-item[data-value="light-duty"]');
        var $heavyDutyOption = $('#dpfVehicleTypeDropdownItems .dpf-form__dropdown-item[data-value="heavy-duty"]');
        var _selectedType = '';
        if ($lightDutyOption.length && !$heavyDutyOption.length) {
          _selectedType = 'light-duty';
        } else if (!$lightDutyOption.length && $heavyDutyOption.length) {
          _selectedType = 'heavy-duty';
        }
        if (_selectedType) {
          populateSearchByOptions(_selectedType);

          // Wait a moment for the dropdown to be populated, then select the default
          setTimeout(function () {
            var $defaultOption = $("#dpfSearchByDropdownItems .dpf-form__dropdown-item[data-value=\"" + defaultSearchBy + "\"]");
            if ($defaultOption.length) {
              // Trigger the click but prevent focus on subsequent fields
              window.dpfDefaultSearchBySelected = true;
              $defaultOption.click();
              setTimeout(function () {
                window.dpfDefaultSearchBySelected = false;
              }, 50);
            }
          }, 100);
        }
      }
    }
  }

  // When a vehicle type is selected
  $(document).on('click', '#dpfVehicleTypeDropdownItems .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var selectedType = $(this).data('value');

    // Clear product context when vehicle type changes
    // This is necessary because we're switching to a completely different vehicle category
    clearProductContext();
    populateSearchByOptions(selectedType);

    // Open and select the Search By dropdown
    $('#dpfSearchByFieldset').find('.dpf-form__input').click();
  });

  // When Search By option is selected
  $(document).on('click', '#dpfSearchByDropdownItems .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var selectedValue = $(this).data('value');

    // Define the products to show when attributes is selected
    var productOptions = [
    // Hiding per Melissa https://basecamp.com/1932235/projects/19078627/messages/105031020#comment_942850105
    // { value: 'ac-compressor', text: 'AC Compressor' },
    {
      value: 'alternators',
      text: 'HD Alternators'
    },
    // Hiding per Melissa https://basecamp.com/1932235/projects/19078627/messages/105031020#comment_941882349
    // { value: 'diesel-aftertreatment', text: 'Diesel Aftertreatment' },
    {
      value: 'starters',
      text: 'HD Starters'
    }];

    // Clear and hide subsequent fieldsets
    clearSubsequentFields('dpfSearchByFieldset');

    // Clear product context when search method changes (unless switching to attributes)
    // This is necessary because we're switching away from the product search flow
    if (selectedValue !== 'attributes') {
      clearProductContext();
    }

    // Show fields based on selection
    var dpfDefaultSearchBySelected = window.dpfDefaultSearchBySelected;
    switch (selectedValue) {
      case 'ymm':
        if (typeof loadYears === 'function') {
          loadYears().then(function (_) {
            $('#dpfVehicleYearFieldset').removeClass('hidden');
            if (!dpfDefaultSearchBySelected) {
              $('#dpfVehicleYearFieldset').find('.dpf-form__input').click();
            }
          });
        }
        break;
      case 'part':
        $('#dpfPartNumberFieldset').removeClass('hidden disabled');
        if (!dpfDefaultSearchBySelected) {
          $('#dpfPartNumberFieldset').find('.dpf-form__input').focus();
        }
        break;
      case 'cross':
        $('#dpfCrossRefFieldset').removeClass('hidden disabled');
        if (!dpfDefaultSearchBySelected) {
          $('#dpfCrossRefFieldset').find('.dpf-form__input').focus();
        }
        break;
      case 'vin':
        $('#dpfVinFieldset').removeClass('hidden disabled');
        if (!dpfDefaultSearchBySelected) {
          $('#dpfVinFieldset').find('.dpf-form__input').focus();
        }
        break;
      case 'attributes':
        productOptions.forEach(function (option) {
          $('#dpfHdProductDropdownItems').append("<li class=\"dpf-form__dropdown-item\" data-value=\"" + option.value + "\">" + option.text + "</li>");
        });
        saveFieldsetOptionsToStorage('dpfHdProductFieldset', productOptions);
        $('#dpfHdProductFieldset').removeClass('hidden disabled');
        if (!dpfDefaultSearchBySelected) {
          $('#dpfHdProductFieldset').find('.dpf-form__input').click();
        }
        break;
    }
  });

  // When Product option is selected
  $(document).on('click', '#dpfHdProductDropdownItems .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var productValue = $(this).data('value');

    // Clear previous product context when product selection changes
    // This is necessary because we're switching to a completely different product
    clearProductContext();
    var partTypeIds = [];
    var nextFieldset = '';
    var nextAttributeId = null;

    // Show fields based on selection
    switch (productValue) {
      case 'ac-compressor':
        partTypeIds = [6628]; // AC Compressor
        break;
      case 'alternators':
        partTypeIds = [2412]; // Alternator
        nextFieldset = 'dpfHdAlternatorFamilyFieldset';
        nextAttributeId = 240; // Family
        break;
      case 'diesel-aftertreatment':
        partTypeIds = [17935, 17937]; // DPF, DOC
        break;
      case 'starters':
        partTypeIds = [4152]; // Starter Motor
        nextFieldset = 'dpfHdStarterFamilyFieldset';
        nextAttributeId = 240; // Family
        break;
    }

    // Convert partTypeIds to a string and set it in the #dpfHdPartTypeIds hidden field
    $('#dpfHdPartTypeIds').val(partTypeIds.join(','));
    clearSubsequentFields('dpfHdProductFieldset');

    // If we have partTypeIds, get parts by those IDs from opticat
    if (partTypeIds.length) {
      if (nextFieldset) {
        // Show the next fieldset first so the loading indicator can be added
        $('#' + nextFieldset).removeClass('hidden disabled');

        // Show loading indicator for the next fieldset
        showLoadingIndicator(nextFieldset);

        // If we have additional fieldsets to show, get the parts now so we can populate those fieldsets based on available attributes
        $.ajax({
          url: dpf.ajax_url,
          type: "POST",
          data: {
            action: "dpf_opticat_parts_by_type",
            nonce: dpf.nonce,
            dpfVehicleType: 'heavy-duty',
            dpfVehiclePartTypes: partTypeIds
          },
          success: function success(response) {
            window.currentPartSet = response.data;

            // Enable the next fieldset
            // Add an 'Any' option because not all parts have a Family attribute set
            $('#' + nextFieldset).find('.dpf-form__dropdown').append("<li class=\"dpf-form__dropdown-item\" data-value=\"Any\">Any</li>");
            // Add options to the next field based on selection
            var attributeValues = collectAttributes(window.currentPartSet, nextAttributeId);
            attributeValues.forEach(function (option) {
              $('#' + nextFieldset).find('.dpf-form__dropdown').append("<li class=\"dpf-form__dropdown-item\" data-value=\"" + option + "\">" + option + "</li>");
            });

            // Add options to local storage for use on the results page
            // Include the "Any" option along with the attribute values
            var allOptions = [{
              value: 'Any',
              text: 'Any'
            }].concat(_toConsumableArray(attributeValues.map(function (option) {
              return {
                value: option,
                text: option
              };
            })));
            saveFieldsetOptionsToStorage(nextFieldset, allOptions);

            // Hide loading indicator
            hideLoadingIndicator(nextFieldset);

            // Open and select the next dropdown
            $('#' + nextFieldset).find('.dpf-form__input').click();
          },
          error: function error(e) {
            console.error(e);
            hideLoadingIndicator(nextFieldset);
          }
        });
      } else {
        // If we don't have additional fieldsets to show, just enable the submit button
        submitButton().attr('disabled', false);
      }
    }

    // Show Clear Filters button when form has data
    showClearFiltersButton();
  });

  // Alternator Family
  $(document).on('click', '#dpfHdAlternatorFamilyFieldset .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var familyValue = $(this).data('value');
    var filteredParts = window.currentPartSet;

    // Clear subsequent fields
    clearSubsequentFields('dpfHdAlternatorFamilyFieldset');

    // Update the current set of parts based on selection
    if (familyValue !== 'Any') {
      filteredParts = filterPartsByAttribute(filteredParts, 240, familyValue);
    }

    // Add options to the next field based on selection
    var attributeValues = collectAttributes(filteredParts, 123);
    attributeValues.forEach(function (option) {
      $('#dpfHdAlternatorVoltageFieldset').find('.dpf-form__dropdown').append("<li class=\"dpf-form__dropdown-item\" data-value=\"" + option + "\">" + option + "</li>");
    });

    // Add options to local storage for use on the results page
    saveFieldsetOptionsToStorage('dpfHdAlternatorVoltageFieldset', attributeValues.map(function (option) {
      return {
        value: option,
        text: option
      };
    }));

    // Open and select the next dropdown
    $('#dpfHdAlternatorVoltageFieldset').removeClass('hidden disabled');
    $('#dpfHdAlternatorVoltageFieldset').find('.dpf-form__input').click();

    // Show Clear Filters button when form has data
    showClearFiltersButton();
  });

  // Alternator Voltage
  $(document).on('click', '#dpfHdAlternatorVoltageFieldset .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var familyValue = $('#dpfHdAlternatorFamily').val();
    var voltageValue = $(this).data('value');
    var filteredParts = window.currentPartSet;

    // Clear subsequent fields
    clearSubsequentFields('dpfHdAlternatorVoltageFieldset');

    // Update the current set of parts based on selection
    if (familyValue !== 'Any') {
      filteredParts = filterPartsByAttribute(filteredParts, 240, familyValue);
    }
    filteredParts = filterPartsByAttribute(filteredParts, 123, voltageValue);

    // Add options to the next field based on selection
    var attributeValues = collectAttributes(filteredParts, 89);
    attributeValues.forEach(function (option) {
      $('#dpfHdAlternatorAmpsFieldset').find('.dpf-form__dropdown').append("<li class=\"dpf-form__dropdown-item\" data-value=\"" + option + "\">" + option + "</li>");
    });

    // Add options to local storage for use on the results page
    saveFieldsetOptionsToStorage('dpfHdAlternatorAmpsFieldset', attributeValues.map(function (option) {
      return {
        value: option,
        text: option
      };
    }));

    // Open and select the next dropdown
    $('#dpfHdAlternatorAmpsFieldset').removeClass('hidden disabled');
    $('#dpfHdAlternatorAmpsFieldset').find('.dpf-form__input').click();

    // Show Clear Filters button when form has data
    showClearFiltersButton();
  });

  // Alternator Amps
  $(document).on('click', '#dpfHdAlternatorAmpsFieldset .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var familyValue = $('#dpfHdAlternatorFamily').val();
    var voltageValue = $('#dpfHdAlternatorVoltage').val();
    var ampsValue = $(this).data('value');
    var filteredParts = window.currentPartSet;

    // Update the current set of parts based on selection
    if (familyValue !== 'Any') {
      filteredParts = filterPartsByAttribute(filteredParts, 240, familyValue);
    }
    filteredParts = filterPartsByAttribute(filteredParts, 123, voltageValue);
    filteredParts = filterPartsByAttribute(filteredParts, 89, ampsValue);

    // Collect Voltage uomCodes and assign to hidden field
    var VoltageUomCodes = collectUomCodes(filteredParts, 123);
    $('#dpfHdAlternatorVoltageUomCodes').val(VoltageUomCodes.join(','));

    // Collect Amps uomCodes and assigne to hidden field
    var ampsUomCodes = collectUomCodes(filteredParts, 89);
    $('#dpfHdAlternatorAmpsUomCodes').val(ampsUomCodes.join(','));
  });

  // Starter Family
  $(document).on('click', '#dpfHdStarterFamilyFieldset .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var familyValue = $(this).data('value');
    var filteredParts = window.currentPartSet;

    // Clear subsequent fields
    clearSubsequentFields('dpfHdStarterFamilyFieldset');

    // Update the current set of parts based on selection
    if (familyValue !== 'Any') {
      filteredParts = filterPartsByAttribute(filteredParts, 240, familyValue);
    }

    // Add options to the next field based on selection
    var attributeValues = collectAttributes(filteredParts, 123);
    attributeValues.forEach(function (option) {
      $('#dpfHdStarterVoltageFieldset').find('.dpf-form__dropdown').append("<li class=\"dpf-form__dropdown-item\" data-value=\"" + option + "\">" + option + "</li>");
    });

    // Add options to local storage for use on the results page
    saveFieldsetOptionsToStorage('dpfHdStarterVoltageFieldset', attributeValues.map(function (option) {
      return {
        value: option,
        text: option
      };
    }));

    // Open and select the next dropdown
    $('#dpfHdStarterVoltageFieldset').removeClass('hidden disabled');
    $('#dpfHdStarterVoltageFieldset').find('.dpf-form__input').click();

    // Show Clear Filters button when form has data
    showClearFiltersButton();
  });

  // Starter Voltage
  $(document).on('click', '#dpfHdStarterVoltageFieldset .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var familyValue = $('#dpfHdStarterFamily').val();
    var voltageValue = $(this).data('value');
    var filteredParts = window.currentPartSet;

    // Clear subsequent fields
    clearSubsequentFields('dpfHdStarterVoltageFieldset');

    // Update the current set of parts based on selection
    if (familyValue !== 'Any') {
      filteredParts = filterPartsByAttribute(filteredParts, 240, familyValue);
    }
    filteredParts = filterPartsByAttribute(filteredParts, 123, voltageValue);

    // Add options to the next field based on selection
    var attributeValues = collectAttributes(filteredParts, 262);
    attributeValues.forEach(function (option) {
      $('#dpfHdStarterPowerRatingFieldset').find('.dpf-form__dropdown').append("<li class=\"dpf-form__dropdown-item\" data-value=\"" + option + "\">" + option + "</li>");
    });

    // Add options to local storage for use on the results page
    saveFieldsetOptionsToStorage('dpfHdStarterPowerRatingFieldset', attributeValues.map(function (option) {
      return {
        value: option,
        text: option
      };
    }));

    // Open and select the next dropdown
    $('#dpfHdStarterPowerRatingFieldset').removeClass('hidden disabled');
    $('#dpfHdStarterPowerRatingFieldset').find('.dpf-form__input').click();

    // Show Clear Filters button when form has data
    showClearFiltersButton();
  });

  // Starter Power Rating
  $(document).on('click', '#dpfHdStarterPowerRatingFieldset .dpf-form__dropdown-item', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var familyValue = $('#dpfHdStarterFamily').val();
    var voltageValue = $('#dpfHdStarterVoltage').val();
    var powerRatingValue = $(this).data('value');
    var filteredParts = window.currentPartSet;

    // Update the current set of parts based on selection
    if (familyValue !== 'Any') {
      filteredParts = filterPartsByAttribute(filteredParts, 240, familyValue);
    }
    filteredParts = filterPartsByAttribute(filteredParts, 123, voltageValue);
    filteredParts = filterPartsByAttribute(filteredParts, 262, powerRatingValue);

    // Collect Voltage uomCodes and assign to hidden field
    var VoltageUomCodes = collectUomCodes(filteredParts, 123);
    $('#dpfHdStarterVoltageUomCodes').val(VoltageUomCodes.join(','));

    // Collect Power Rating uomCodes and assigne to hidden field
    var powerRatingUomCodes = collectUomCodes(filteredParts, 262);
    $('#dpfHdStarterPowerRatingUomCodes').val(powerRatingUomCodes.join(','));

    // Show Clear Filters button when form has data
    showClearFiltersButton();
  });
  function filterPartsByAttribute(parts, attributeId, value) {
    return parts.filter(function (item) {
      return item.piesItem.productAttributes.some(function (attribute) {
        return attribute.attributeId == attributeId && attribute.value == value;
      });
    });
  }
  function collectAttributes(parts, attributeId) {
    var valuesSet = new Set();
    parts.forEach(function (item) {
      var productAttributes = item.piesItem.productAttributes;
      productAttributes.forEach(function (attribute) {
        if (attribute.padbAttributeId === attributeId) {
          valuesSet.add(attribute.value);
        }
      });
    });

    // Convert Set to Array and sort the result
    var uniqueValues = Array.from(valuesSet).sort();

    // // Filter out Power Edge families
    // if (attributeId === 240) {
    // 	const familyValues = ['24 PEAlternator', '39PE', '42 PE', '42 PE Starter'];
    // 	uniqueValues = uniqueValues.filter(value => !familyValues.includes(value));
    // }

    return uniqueValues;
  }
  function collectUomCodes(parts, attributeId) {
    return [].concat(_toConsumableArray(new Set(parts.flatMap(function (part) {
      return part.piesItem.productAttributes.filter(function (attribute) {
        return attribute.attributeId == attributeId;
      }).map(function (attribute) {
        return attribute.uomCode;
      });
    }))));
  }
  function clearSubsequentFields(currentField) {
    var excludeFieldsets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    // List of fieldsets in order of appearance
    var fieldSets = [{
      id: 'dpfVehicleTypeFieldset',
      hide: false,
      removeOptions: false
    }, {
      id: 'dpfSearchByFieldset',
      hide: false,
      removeOptions: true
    },
    //* Passenger Vehicle Search
    // YMM
    {
      id: 'dpfVehicleYearFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfVehicleMakeFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfVehicleModelFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfVehicleEngineFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfVehicleTrimFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfVehiclePartTypesFieldset',
      hide: true,
      removeOptions: true
    },
    //* HD Attributes Search
    {
      id: 'dpfHdProductFieldset',
      hide: true,
      removeOptions: true
    },
    // A/C Compressor
    // Alternators
    {
      id: 'dpfHdAlternatorFamilyFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfHdAlternatorVoltageFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfHdAlternatorAmpsFieldset',
      hide: true,
      removeOptions: true
    },
    // Diesel Aftertreatment
    // Starters
    {
      id: 'dpfHdStarterFamilyFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfHdStarterVoltageFieldset',
      hide: true,
      removeOptions: true
    }, {
      id: 'dpfHdStarterPowerRatingFieldset',
      hide: true,
      removeOptions: true
    },
    //* Part Number/Cross Reference Search
    {
      id: 'dpfPartNumberFieldset',
      hide: true,
      removeOptions: false
    }, {
      id: 'dpfCrossRefFieldset',
      hide: true,
      removeOptions: false
    },
    //* VIN Search
    {
      id: 'dpfVinFieldset',
      hide: true,
      removeOptions: false
    }];

    // Iterate over the fieldset list and clear subsequent fields
    var clear = false;
    for (var i = 0; i < fieldSets.length; i++) {
      if (clear) {
        // Skip fieldsets that should be excluded
        if (!excludeFieldsets.includes(fieldSets[i].id)) {
          clearField(fieldSets[i].id, fieldSets[i].hide, fieldSets[i].removeOptions);
        }
      }
      if (fieldSets[i].id === currentField) {
        clear = true;
      }
    }
  }
  function clearField(fieldsetId) {
    var hide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var removeOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var $fieldset = $("#" + fieldsetId);
    var $label = $fieldset.find('label');
    var $input = $fieldset.find('input');
    var $span = $fieldset.find('.dpf-form__active-value span');
    var $dropdown = $fieldset.find('.dpf-form__dropdown');

    // Remove focus from label
    $label.removeClass('in-focus');

    // Clear input value
    $input.val('');

    // Clear span text
    $span.text('');

    // Hide fieldset if specified
    if (hide) {
      $fieldset.addClass('hidden');
    }

    // Empty dropdown items if specified
    if (removeOptions && $dropdown.length) {
      $dropdown.empty();
    }
  }

  /**
   * Save fieldset options to localStorage
   * @param {string} fieldsetId - The ID of the fieldset
   * @param {Array} options - Array of option objects with value and text properties
   */
  function saveFieldsetOptionsToStorage(fieldsetId, options) {
    var dpfFormOptions = JSON.parse(localStorage.getItem('dpfFormOptions') || '[]');

    // Check if this fieldset already exists and replace it, otherwise add it
    var existingIndex = dpfFormOptions.findIndex(function (option) {
      return option.fieldset === fieldsetId;
    });
    if (existingIndex !== -1) {
      dpfFormOptions[existingIndex] = {
        fieldset: fieldsetId,
        options: options
      };
    } else {
      dpfFormOptions.push({
        fieldset: fieldsetId,
        options: options
      });
    }
    localStorage.setItem('dpfFormOptions', JSON.stringify(dpfFormOptions));
  }

  /**
   * Save product context (window.currentPartSet) to localStorage for restoration on page reload
   * @param {Array} parts - The parts array to save
   * @param {string} productType - The type of product (e.g., 'alternators', 'starters')
   */
  function saveProductContextToStorage(parts, productType) {
    localStorage.setItem('dpfProductContext', JSON.stringify({
      parts: parts,
      productType: productType,
      timestamp: Date.now()
    }));
  }

  /**
   * Restore product context from localStorage if available and not expired
   * @returns {Array|null} The restored parts array or null if not available/expired
   */
  function restoreProductContextFromStorage() {
    var stored = localStorage.getItem('dpfProductContext');
    if (!stored) return null;
    try {
      var context = JSON.parse(stored);
      // Check if the context is not too old (24 hours)
      var maxAge = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
      if (Date.now() - context.timestamp > maxAge) {
        localStorage.removeItem('dpfProductContext');
        return null;
      }
      return context.parts;
    } catch (e) {
      console.error('Error parsing stored product context:', e);
      localStorage.removeItem('dpfProductContext');
      return null;
    }
  }

  /**
   * Clear product context from localStorage and global variables
   */
  function clearProductContext() {
    localStorage.removeItem('dpfProductContext');
    if (window.currentPartSet) {
      window.currentPartSet = null;
    }
  }

  // Loading indicator functions
  function showLoadingIndicator(fieldsetId) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dropdown';
    var $fieldset = $("#" + fieldsetId);
    var $input = $fieldset.find('.dpf-form__input');
    var $dropdown = $fieldset.find('.dpf-form__dropdown-wrapper');
    var $label = $fieldset.find('label');

    // Create loading spinner if it doesn't exist
    if ($fieldset.find('.dpf-loading-spinner').length === 0) {
      var spinner = '<div class="dpf-loading-spinner lds-ring-small"><div></div><div></div><div></div><div></div></div>';
      $input.append(spinner);
    }

    // Show spinner and disable interaction
    $fieldset.find('.dpf-loading-spinner').removeClass('hidden');
    $input.addClass('loading');
    $dropdown.addClass('disabled');

    // Hide the label so that it doesn't overlap the spinner
    $label.addClass('hidden');

    // Ensure the fieldset is visible so the loading indicator can be seen
    $fieldset.removeClass('hidden');
  }
  function hideLoadingIndicator(fieldsetId) {
    var $fieldset = $("#" + fieldsetId);
    var $input = $fieldset.find('.dpf-form__input');
    var $dropdown = $fieldset.find('.dpf-form__dropdown-wrapper');
    var $label = $fieldset.find('label');

    // Hide spinner and re-enable interaction
    $fieldset.find('.dpf-loading-spinner').addClass('hidden');
    $input.removeClass('loading');
    $dropdown.removeClass('disabled');
    $label.removeClass('hidden');

    // Ensure label visibility reflects value presence correctly
    var hasValue = Boolean($fieldset.find('.dpf-form__input-selected').val() || $fieldset.find('.dpf-form__active-value span').text().trim());
    if (!hasValue) {
      // Also hide the fieldset if it was originally hidden and has no content
      if ($fieldset.hasClass('disabled')) {
        $fieldset.addClass('hidden');
      }
    }
  }
  function showFormLoading() {
    $('#dpfVehicleSearchSubmit').prop('disabled', true).text('Searching...');
    $('#dpfSearching').removeClass('hidden');
  }
  function hideFormLoading() {
    $('#dpfVehicleSearchSubmit').prop('disabled', false).text('Search');
    $('#dpfSearching').addClass('hidden');
  }

  /**
   * Reset the entire form to its initial state
   * This consolidates all form clearing logic into one place
   */
  function resetFormToInitialState() {
    var excludeFieldsets = [];

    // Don't reset Vehicle Type fieldset if it's auto-selected
    var $vehicleTypeFieldset = $('#dpfVehicleTypeFieldset');
    var vehicleTypeAutoSelected = $vehicleTypeFieldset.hasClass('hidden') && $('#dpfVehicleType').val();
    vehicleTypeAutoSelected && excludeFieldsets.push('dpfVehicleTypeFieldset');

    // If Search By is auto-selected, reset it to the default value
    var defaultSearchBy = $('#dpfVehicleSearchForm').data('default-search-by');
    if (vehicleTypeAutoSelected && defaultSearchBy) {
      excludeFieldsets.push('dpfSearchByFieldset');
      initDefaultSearchByOnReady();
    }

    // Use clearSubsequentFields to clear all fields starting from the first fieldset
    clearSubsequentFields('dpfVehicleTypeFieldset', excludeFieldsets);

    // Reset Vehicle Type and Search By fieldsets to their initial state
    if (vehicleTypeAutoSelected) {
      // Keep Vehicle Type hidden and enabled
      $('#dpfVehicleTypeFieldset').addClass('hidden').removeClass('disabled');
      // Keep Search By enabled
      $('#dpfSearchByFieldset').removeClass('hidden disabled');
    } else {
      // Clear Vehicle Type field if it's not auto-selected
      clearField('dpfVehicleTypeFieldset', false, false);
      // Show Vehicle Type and disable Search By
      $('#dpfVehicleTypeFieldset').removeClass('hidden disabled');
      $('#dpfSearchByFieldset').removeClass('hidden').addClass('disabled');
    }

    // Reset form-specific elements
    resetFormSpecificElements();

    // Clear any stored form options
    localStorage.removeItem('dpfFormOptions');

    // Clear product context
    clearProductContext();
  }

  /**
   * Reset form-specific elements that don't fit the standard pattern
   */
  function resetFormSpecificElements() {
    // Show separators
    $(".dpf-form__separator, .dpf-form__separator + fieldset").show();

    // Disable submit button
    $("#dpfVehicleSearchSubmit").attr("disabled", true);

    // Reset tablet layout
    if (window.innerWidth >= navBreak) {
      $(".dpf-form").removeClass("tablet-all-drops");
    }

    // Hide Clear Filters button by default
    $(".dpf-form__clear-filters").addClass('hidden');
  }

  /**
   * Show the Clear Filters button when the form has data
   */
  function showClearFiltersButton() {
    // If we're currently applying the default Search By programmatically, do not show
    if (window.dpfDefaultSearchBySelected) return;
    // Check if Vehicle Type is auto-selected (hidden due to admin config)
    var $vehicleTypeFieldset = $('#dpfVehicleTypeFieldset');
    var vehicleTypeAutoSelected = $vehicleTypeFieldset.hasClass('hidden') && $('#dpfVehicleType').val();

    // Check if any form field has a value, excluding auto-selected Vehicle Type
    var hasFormData = false;

    // Check input fields
    $('.dpf-form__input-selected').each(function () {
      var $input = $(this);
      var fieldsetId = $input.closest('fieldset').attr('id');

      // Skip Vehicle Type if it's auto-selected
      if (fieldsetId === 'dpfVehicleTypeFieldset' && vehicleTypeAutoSelected) {
        return;
      }
      if ($input.val() !== '') {
        hasFormData = true;
        return false; // break the loop
      }
    });

    // Check active value spans
    if (!hasFormData) {
      $('.dpf-form__active-value span').each(function () {
        var $span = $(this);
        var fieldsetId = $span.closest('fieldset').attr('id');

        // Skip Vehicle Type if it's auto-selected
        if (fieldsetId === 'dpfVehicleTypeFieldset' && vehicleTypeAutoSelected) {
          return;
        }
        if ($span.text().trim() !== '') {
          hasFormData = true;
          return false; // break the loop
        }
      });
    }

    // Check checkbox selections
    if (!hasFormData) {
      hasFormData = $('.dpf-form__dropdown-item input[type="checkbox"]:checked').length > 0;
    }
    if (hasFormData) {
      $(".dpf-form__clear-filters").removeClass('hidden');
    }
  }
})(jQuery);

},{}]},{},[1]);
